import React from 'react';
import {XMarkIcon} from "@heroicons/react/24/solid";
import {ApprovalType} from "../../constant/CodeSpecNum";

const BadgeView = ({data, deleteItem, approvedId}) => {
    return (
        <div className={"h-full"} style={{display: 'flex', flexWrap: 'wrap', gap: '5px'}}>
            {data && data.length > 0 && data.map((item, index) => (
                <Badge key={index} item={item} deleteItem={deleteItem} approvedId={approvedId}/>
            ))}
        </div>
    );
};

const Badge = ({item, deleteItem, approvedId}) => {
    // console.log("item", item, `item.approverId: ${item.approverId}`, `approvedId: ${approvedId}`,item.approverId === approvedId);
    return (
        <div
            className={`inline-flex justify-between gap-2 items-center shadow-lg rounded-full border px-2.5 py-1.5 text-xs transition-colors 
                ${deleteItem ? 'cursor-pointer' : ''} 
                ${approvedId && approvedId === item.approverId && item.approvalType === ApprovalType.APPROVED ? `bg-[black] text-[white]` :
                    (approvedId === item.approverId && item.approvalType === ApprovalType.REJECTED ? `bg-[#1c90fb] text-[white]` : `bg-[white]`)}`}
            onClick={deleteItem && (() => deleteItem(item))}
        >
            <div className={"max-w-[10rem] text-breaker"}>{`${item.name}`}</div>
            {item.department && <div>{item.department ? `[${item.department.name}]` : ""}</div>}
            {deleteItem && (
                <div className={"flex items-center cursor-pointer rounded-full"}>
                    <XMarkIcon className={"h-4 w-4 "}/>
                </div>
            )}
        </div>
    )
}

export {BadgeView, Badge};